<template lang="html">
  <v-container class='fluid'>

    <!-- Mensagem mostrada ao clicar no botão "Criar" -->
    <v-dialog v-model="dialogConfirmaCadastro" width="550" persistent>

      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>Confirma o cadastro da ação de
          extensão?</v-card-title>

        <!-- Mensagem mostrada em caso de cursos/oficina (39729) ou curso (44194) ou oficina (44195) ou eventos (39730) de extensão com registro tardio -->
        <div v-if="cursoOuEvento && registroTardio">

          <v-card-text class="title" align="justify" style="word-break: break-word; margin-top: 10px;">
            A submissão de uma proposta de ação retroativa deve ser acompanhada, obrigatoriamente, do relatório da
            respectiva ação.
          </v-card-text>

        </div>

        <v-divider></v-divider>

        <v-card-actions>
          <v-btn color="primary" text @click="dialogConfirmaCadastro = false">Não</v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="criarNovoProjeto()">Sim</v-btn>
        </v-card-actions>

      </v-card>

    </v-dialog>

    <v-layout align-center justify-center>
      <v-flex xs12>
        <v-card class="text-xs-center">
          <basic-toolbar :title="'Novo Projeto'"></basic-toolbar>
          <v-card-text>
            <v-form v-model="formularioValido" ref="form">
              <v-container>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-text-field label='Título' v-model="projeto.titulo" required :rules="tituloRules" max-height="400"
                      counter="150">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select label='Classificação primária' :items="listaClassificacaoPrimaria"
                      v-model="projeto.classificacaoPrimaria" item-text="descricao" item-value="id"
                      prepend-icon="dashboard" max-height="400" return-object required autocomplete readonly
                      :rules="regrasBasicas">
                    </v-select>
                  </v-flex>

                  <v-flex xs11 sm5>
                    <v-select label='Classificação secundária' :items="listaClassificacaoSecundaria"
                      v-model="projeto.classificacaoSecundaria" item-text="descricao" item-value="id"
                      prepend-icon="dashboard" max-height="400" return-object required autocomplete :rules="regrasBasicas"
                      @change="limparDataConclusaoSemLimite()">
                    </v-select>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm5>
                    <v-select label='Tipo de público-alvo' :items="listaTipoPublico" v-model="projeto.tipoPublico"
                      item-text="descricao" item-value="id" prepend-icon="dashboard" max-height="400" return-object
                      required autocomplete :rules="regrasBasicas">
                    </v-select>
                  </v-flex>
                  <v-flex xs11 sm5>
                    <v-text-field-integer v-model="projeto.publicoAlvo" label='Público-alvo estimado' v-bind:properties="{
                      rules: numerico
                    }" />
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria && projeto.classificacaoSecundaria.id === 44194">
                    <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária do curso" v-bind:properties="{
                      rules: numerico
                    }" />
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria && projeto.classificacaoSecundaria.id === 44195">
                    <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária da oficina"
                      v-bind:properties="{
                        rules: numerico
                      }" />
                  </v-flex>
                </v-layout>

                <v-layout>
                  <v-flex xs11 sm5 v-if="projeto.classificacaoSecundaria && projeto.classificacaoSecundaria.id === 39730">
                    <v-text-field-integer v-model="projeto.cargaHoraria" label="Carga horária do evento"
                      v-bind:properties="{
                        rules: numerico
                      }" />
                  </v-flex>
                </v-layout>

                <p class="mt-3"></p>

                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <v-checkbox
                      v-if="(projeto.classificacaoSecundaria && projeto.classificacaoSecundaria.id === 39733)"
                      v-model="dataConclusaoSemLimite" :value="true" @change="onChangeDataSemLimite">
                      <template v-slot:label>
                        <div>Essa é uma ação contínua, sem data limite</div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-layout>

                <v-layout row wrap>
                  <v-flex xs11 sm5>
                    <c-date-menu label="Data de início" v-model="projeto.dataInicio" required
                      :rules="regrasBasicas"></c-date-menu>
                  </v-flex>
                  <v-spacer></v-spacer>
                  <v-flex xs11 sm5>
                    <c-date-menu label="Data de conclusão" v-model="projeto.dataConclusao" :rules="dataConclusaoRules"
                      :disabled="dataConclusaoSemLimite"></c-date-menu>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs11 sm2>
                    <v-text-field label='Palavra-chave 1' v-model="projeto.palavraChave01" required :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm2>
                    <v-text-field label='Palavra-chave 2' v-model="projeto.palavraChave02" required :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm2>
                    <v-text-field label='Palavra-chave 3' v-model="projeto.palavraChave03" required :rules="regrasBasicas"
                      max-height="400">
                    </v-text-field>
                  </v-flex>
                  <v-flex xs11 sm2>
                    <v-text-field label='Palavra-chave 4' v-model="projeto.palavraChave04" max-height="400">
                    </v-text-field>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-textarea label="Resumo" v-model="projeto.resumo" required :rules="resumoRules" :rows="3"
                      :auto-grow="true" multi-line counter="1000">
                    </v-textarea>
                  </v-flex>
                </v-layout>

                <v-layout row wrap justify-space-between>
                  <v-flex xs12>
                    <v-checkbox v-model="aceiteTermoCompromisso" :value="true">
                      <template v-slot:label>
                        <div style="text-align: justify;">
                          {{ termoCompromissoTexto }}
                        </div>
                      </template>
                    </v-checkbox>
                  </v-flex>
                </v-layout>

              </v-container>
            </v-form>
            <v-divider></v-divider>
            <v-card-actions>
              <v-btn color="primary" text @click="$router.go(-1)">Cancelar</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="abreDialogCadastroAcaoExtensao()"
                :disabled="!formularioValido || !aceiteTermoCompromisso">Criar</v-btn>
            </v-card-actions>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import ToolTip from '@/components/app-layouts/app-tooltip/tooltip'
import DataMenu from '@/components/c-date-menu'
import TextArea from '@/components/c-textarea'
import BasicToolbar from '@/components/toolbars/basic-toolbar'
import dates from '@/utils/dates'
import projetos from '@/utils/projetos'
import { mapActions, mapGetters } from 'vuex'

export default {
  data: () => ({
    formularioValido: false,
    aceiteTermoCompromisso: false,
    termoCompromissoTexto: `Declaro, na qualidade de coordenador(a), ter pleno conhecimento das normativas institucionais vigentes
    que regem a extensão universitária na UFES e que a presente proposta está condizente com essas normativas e diretrizes.
    Comprometo-me a cumpri-las integralmente em todas as etapas da ação — desde a elaboração até a certificação e relatórios finais —,
    garantindo o respeito e o atendimento ao interesse público. Declaro também que esta proposta de ação de extensão encontrará,
    na sociedade, uma oportunidade de construção conjunta de práticas baseadas no intercâmbio de saberes, contribuindo para uma
    sociedade mais inclusiva, dialógica e responsável. Declaro ainda estar ciente de que o descumprimento das normas poderá acarretar
    sanções conforme previsto nos regulamentos da UFES.`,
    dialogConfirmaCadastro: false,
    cursoOuEvento: false,
    registroTardio: false,
    dates: dates,
    dataConclusaoSemLimite: false,
    projeto: {
      titulo: '',
      projetoSup: undefined,
      dataInicio: '',
      dataConclusao: '',
      resumo: '',
      termoCompromisso: '',
      tipoPublico: undefined,
      cargaHoraria: null,
      publicoAlvo: null,
      classificacaoPrimaria: null,
      classificacaoSecundaria: null,
      classificacoesPrimariaSecundaria: []
    },
    pesquisa: {
      titulo: ''
    },
    listaTipoPublico: [],
    listaTipoEvento: [],
    listaSituacao: [],
    listaClassificacaoPrimaria: [
      {
        'id': 39725,
        'classificacaoItem': 90,
        'tipoClassificacao': 'Tipo de Projeto',
        'descricao': 'Extensão'
      }
    ],
    listaClassificacaoSecundaria: [],
    dialog: false,
    regrasBasicas: [
      (input) => !!input || 'Este campo é obrigatório'
    ],
    dataConclusaoRules: [
      (input) => !!input || 'Este campo é obrigatório'
    ],
    tituloRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 150 || 'Este campo não pode possuir mais que 150 caracteres'
    ],
    resumoRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 1000 || 'Este campo não pode possuir mais que 1000 caracteres'
    ],
    publicoAlvoEstimadoRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !isNaN(parseFloat(input)) && input > 0 && input <= 10000000 || 'Público-alvo estimado inválido'
    ],
    assuntoSummaryRules: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !!input && input.length <= 200 || 'Este campo não pode possuir mais que 200 caracteres'
    ],
    numerico: [
      (input) => !!input || 'Este campo é obrigatório',
      (input) => !isNaN(input) || 'Este campo deve ser numérico',
      (input) => (input.length === 0 || Number(input) !== 0) || 'Este campo não pode ser nulo',
      (input) => (input.length === 0 || Number(input) >= 0) || 'Este campo não pode ter valor negativo'
    ],
    search: null,
    sortBy: 'dtCriacao',
    sortDesc: true,
    itemsPerPage: 25,
    opcoesPaginacao: [10, 25, 50, { text: 'Todas', value: -1 }],
    headers: [
      { text: 'Número', align: 'center', value: 'idProjeto' },
      { text: 'Título', align: 'center', value: 'titulo' },
      { text: 'Classificação primária', align: 'center', value: 'classificacaoPrimaria.descricao' },
      { text: 'Classificação secundária', align: 'center', value: 'classificacaoSecundaria.descricao' },
      { text: 'Situação', align: 'center', value: 'situacao.descricao' },
      { text: 'Início', align: 'center', value: 'dataCriacao' }
    ]
  }),
  computed: {
    ...mapGetters('autuacao', [
      'listaTipoDocumento',
      'tipoDocumento',
      'listaUnidadeProcedencia',
      'unidadeProcedencia',
      'listaTipoInteressado',
      'tipoInteressado',
      'listaEntidadeInteressada',
      'entidadeInteressada',
      'assunto'
    ]),
    entidadeInteressadaComCodigo: function () {
      return (this.entidadeInteressada.codigo && this.entidadeInteressada.nome) ? ('[' + this.entidadeInteressada.codigo + '] ' + this.entidadeInteressada.nome) : null
    },
    concatenatedSubject: function () {
      return (this.assunto.codigo && this.assunto.descricao) ? ('[' + this.assunto.codigo + '] ' + this.assunto.descricao) : null
    },
    temVinculo: function () {
      if (this.projeto && this.projeto.classificacaoSecundaria) {
        return this.projeto.classificacaoSecundaria.id !== 39733
      } else {
        return false
      }
    }
  },
  methods: {
    ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
    truncate: function (string, limit) {
      if (string.length > limit) return string.substring(0, limit) + '...'
      else return string
    },
    onChangeDataSemLimite: function () {
      this.projeto.dataConclusao = undefined
      if (this.dataConclusaoSemLimite) {
        this.dataConclusaoRules = [true]
      } else {
        this.dataConclusaoRules = [
          (input) => !!input || 'Este campo é obrigatório'
        ]
      }
    },
    abreDialogCadastroAcaoExtensao: function () {
      this.dialogConfirmaCadastro = true
      // Curso/Oficina (39729) ou Curso (44194) ou Oficina (44195) ou Evento (39730)
      if (this.projeto.classificacaoSecundaria.id === 39729 || this.projeto.classificacaoSecundaria.id === 44194 || this.projeto.classificacaoSecundaria.id === 44195 || this.projeto.classificacaoSecundaria.id === 39730) {
        this.cursoOuEvento = true
        this.verificaCursoEventoRegistroTardio()
      } else {
        this.cursoOuEvento = false
      }
    },
    limparProjetoSup: function () {
      this.projeto.projetoSup = undefined
    },
    limparDataConclusaoSemLimite: function () {
      this.dataConclusaoSemLimite = false
      this.dataConclusaoRules = [
        (input) => !!input || 'Este campo é obrigatório'
      ]
    },
    // Verifica se o registro do curso ou evento é tardio.
    verificaCursoEventoRegistroTardio: function () {
      if (this.cursoOuEvento) {
        // Obtém a data atual.
        var today = new Date()
        var dd = String(today.getDate()).padStart(2, '0')
        var mm = String(today.getMonth() + 1).padStart(2, '0')
        var yyyy = today.getFullYear()
        today = yyyy + '-' + mm + '-' + dd
        var dataAtual = new Date(today)
        // Obtém a data de conclusão do curso ou evento.
        var dataConclusao = new Date(this.projeto.dataConclusao)
        // Verifica se o registro é tardio.
        if (dataConclusao.getTime() < dataAtual.getTime()) {
          this.registroTardio = true
        } else {
          this.registroTardio = false
        }
      }
    },
    selecionarProjeto: function (projeto) {
      this.projeto.projetoSup = Object.assign({}, this.projetoSup, { idProjeto: projeto.idProjeto, titulo: projeto.titulo })
      this.dialog = false
    },
    criarNovoProjeto: function () {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Criando Projeto.' })
      this.projeto.classificacoesPrimariaSecundaria = [this.projeto.classificacaoPrimaria, this.projeto.classificacaoSecundaria]
      this.projeto.termoCompromisso = this.termoCompromissoTexto
      projetos.postProjeto(this.projeto)
        .then(response => {
          this.SHOW_SNACKBAR({ snackbarType: 'success', snackbarText: response.body.mensagem })
          let idProjetoNovo = response.body.link.split('/').pop()
          this.$router.push({ name: 'ProjetoFormulario', params: { idProjeto: idProjetoNovo } })
        })
        .catch(error => {
          this.SHOW_SNACKBAR({ snackbarType: 'error', snackbarText: error.body.mensagem })
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
        })
    },
    obterClassificacoes: function (itemTabela, aqui, atributo) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' })
      projetos.getClassificacoesPossiveis(itemTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando classificações.' })
        })
    },
    opcoesTabelaEstruturada: function (codTabela, aqui, atributo) {
      this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando opções.' })
      return projetos.getOpcoesTabelaEstruturada(codTabela)
        .then(response => {
          aqui[atributo] = response.data.slice()
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Carregando projeto.' })
        })
    }
  },
  mounted: function () {
    this.opcoesTabelaEstruturada(6011, this, 'listaSituacao')
    this.opcoesTabelaEstruturada(6002, this, 'listaTipoPublico')
    .then(() => {
      // mantém apenas itens 14 e 15
      this.listaTipoPublico = this.listaTipoPublico.filter(
        (item) => item.item === 14 || item.item === 15
      )
    })
    this.opcoesTabelaEstruturada(6028, this, 'listaTipoEvento')
    //      this.obterClassificacoes(90, this, 'listaClassificacaoPrimaria')
    this.obterClassificacoes(91, this, 'listaClassificacaoSecundaria')
    this.projeto.classificacaoPrimaria =
    {
      'id': 39725,
      'classificacaoItem': 90,
      'tipoClassificacao': 'Tipo de Projeto',
      'descricao': 'Extensão'
    }
  },
  components: {
    'basic-toolbar': BasicToolbar,
    'tooltip': ToolTip,
    'c-date-menu': DataMenu,
    'c-textarea': TextArea
  }
}
</script>

<style lang="css">
.menu {
  display: block !important;
}

.no-resize div textarea {
  resize: none;
}

.input-group__icon-cb {
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// novo-projeto.vue?2d8b95b6